module.exports = __webpack_public_path__ + "static/media/22791606_1629543967120788_212147007377581115_o.3304c2d7.jpg";